import { ContainerType } from './ContainerType'
import Container from './Container'

export default class SimpleContainer extends Container {
  constructor () {
    super(ContainerType.SIMPLE, true)
  }

  style (bid, slot, media) {
    const container = slot.container()
    container.style.display = 'flex'
    container.style['justify-content'] = 'center'
    container.style.width = '100%'
    if (!slot.node().style.width) {
      slot.node().style.width = '100%'
    }
    slot.node().style.display = 'flex'
    slot.node().style['justify-content'] = 'center'
  }
}
